/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsObjectExclude: {
  name: 'object-exclude';
  data: string;
} = {
  name: 'object-exclude',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 8h5a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-5H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v5Zm-6 8h.5a1 1 0 1 0 0-2H10v-.5a1 1 0 1 0-2 0v.5H3V3h11v5h-.5a1 1 0 1 0 0 2h.5v.5a1 1 0 1 0 2 0V10h5v11H10v-5Zm3.5 0a1 1 0 1 1 0-2h.5v-.5a1 1 0 1 1 2 0v.5a2 2 0 0 1-2 2h-.5Zm-2-7a1 1 0 0 0-1-1H10a2 2 0 0 0-2 2v.5a1 1 0 1 0 2 0V10h.5a1 1 0 0 0 1-1Z" fill="currentColor"/></svg>`,
};
